import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
        color: "var(--itsm-bg-btn)",
        background: "#fff",
        boxShadow: "none",
        border: "1px solid var(--itsm-bg-btn)",
        '&.MuiButton-contained.Mui-disabled': {
            background: "#fff",
            color: "var(--itsm-bg-btn)",
            border: "1px solid var(--itsm-bg-btn)",

        },
        '&:hover': {
            borderColor: "var(--itsm-bg-btn)",
            background: "#fff",
        },
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));